/**
 * Willow & Dove — Global JavaScript
 * Nav scroll shadow, mega menu dropdowns, mobile accordion, scroll animations, cart badge
 */

(function() {
  'use strict';

  // ── Screen reader announcement helper ──────────────────
  window.wdAnnounce = function(message) {
    var el = document.getElementById('sr-announcements');
    if (el) { el.textContent = message; }
  };

  // ── Sticky nav shadow on scroll ──────────────────────────
  var nav = document.getElementById('nav');
  if (nav) {
    window.addEventListener('scroll', function() {
      nav.classList.toggle('scrolled', window.scrollY > 10);
    }, { passive: true });
  }

  // ── Desktop Mega Menu (hover + click) ────────────────────
  var dropdowns = document.querySelectorAll('.nav__dropdown');
  var closeTimer = null;

  function openDropdown(dd) {
    // Close all others first
    dropdowns.forEach(function(other) {
      if (other !== dd) closeDropdown(other);
    });
    dd.classList.add('open');
    var trigger = dd.querySelector('.nav__dropdown-trigger');
    var panel = dd.querySelector('.nav__mega');
    if (trigger) trigger.setAttribute('aria-expanded', 'true');
    if (panel) panel.setAttribute('aria-hidden', 'false');
  }

  function closeDropdown(dd) {
    dd.classList.remove('open');
    var trigger = dd.querySelector('.nav__dropdown-trigger');
    var panel = dd.querySelector('.nav__mega');
    if (trigger) trigger.setAttribute('aria-expanded', 'false');
    if (panel) panel.setAttribute('aria-hidden', 'true');
  }

  function closeAllDropdowns() {
    dropdowns.forEach(closeDropdown);
  }

  dropdowns.forEach(function(dd) {
    var trigger = dd.querySelector('.nav__dropdown-trigger');

    // Mouse enter — open with small delay to prevent flicker
    dd.addEventListener('mouseenter', function() {
      if (closeTimer) { clearTimeout(closeTimer); closeTimer = null; }
      openDropdown(dd);
    });

    // Mouse leave — close with delay so user can move to mega menu
    dd.addEventListener('mouseleave', function() {
      closeTimer = setTimeout(function() {
        closeDropdown(dd);
      }, 200);
    });

    // Click: on desktop (hover available), let the link navigate naturally.
    // On touch devices (no hover), first tap opens menu, second tap navigates.
    if (trigger) {
      trigger.addEventListener('click', function(e) {
        var isTouch = 'ontouchstart' in window || navigator.maxTouchPoints > 0;
        if (isTouch && !dd.classList.contains('open')) {
          // First tap on touch: open the menu, don't navigate
          e.preventDefault();
          openDropdown(dd);
        }
        // Desktop click or second touch tap: let the <a> navigate naturally
      });
    }

    // Keyboard: Escape closes
    dd.addEventListener('keydown', function(e) {
      if (e.key === 'Escape') {
        closeDropdown(dd);
        if (trigger) trigger.focus();
      }
    });
  });

  // Close dropdowns when clicking outside
  document.addEventListener('click', function(e) {
    if (!e.target.closest('.nav__dropdown')) {
      closeAllDropdowns();
    }
  });

  // ── Mobile menu toggle ───────────────────────────────────
  var toggle = document.getElementById('mobileToggle');
  var menu = document.getElementById('mobileMenu');

  if (toggle && menu) {
    toggle.addEventListener('click', function() {
      var isOpen = menu.classList.toggle('open');
      toggle.setAttribute('aria-expanded', isOpen);
      menu.setAttribute('aria-hidden', !isOpen);
      document.body.style.overflow = isOpen ? 'hidden' : '';
      // Close all desktop dropdowns when opening mobile
      closeAllDropdowns();
      // Move focus into menu when opened
      if (isOpen) {
        var firstFocusable = menu.querySelector('a, button');
        if (firstFocusable) firstFocusable.focus();
      }
    });

    // Close menu when a direct link is clicked
    menu.querySelectorAll('.nav__mobile-link').forEach(function(link) {
      link.addEventListener('click', function() {
        menu.classList.remove('open');
        toggle.setAttribute('aria-expanded', 'false');
        menu.setAttribute('aria-hidden', 'true');
        document.body.style.overflow = '';
      });
    });

    // Close menu when sub-link is clicked
    menu.querySelectorAll('.nav__mobile-accordion-panel a').forEach(function(link) {
      link.addEventListener('click', function() {
        menu.classList.remove('open');
        toggle.setAttribute('aria-expanded', 'false');
        menu.setAttribute('aria-hidden', 'true');
        document.body.style.overflow = '';
      });
    });
  }

  // ── Mobile accordion ─────────────────────────────────────
  var accordionTriggers = document.querySelectorAll('.nav__mobile-accordion-trigger');
  accordionTriggers.forEach(function(trigger) {
    trigger.addEventListener('click', function() {
      var panel = trigger.nextElementSibling;
      var isOpen = trigger.getAttribute('aria-expanded') === 'true';

      // Close all other accordions
      accordionTriggers.forEach(function(other) {
        if (other !== trigger) {
          other.setAttribute('aria-expanded', 'false');
          var otherPanel = other.nextElementSibling;
          if (otherPanel) otherPanel.setAttribute('aria-hidden', 'true');
        }
      });

      // Toggle this one
      trigger.setAttribute('aria-expanded', !isOpen);
      if (panel) panel.setAttribute('aria-hidden', isOpen);
    });
  });

  // ── Scroll-triggered animations (IntersectionObserver) ───
  if ('IntersectionObserver' in window) {
    var observer = new IntersectionObserver(function(entries) {
      entries.forEach(function(entry, i) {
        if (entry.isIntersecting) {
          setTimeout(function() {
            entry.target.classList.add('visible');
          }, i * 80);
          observer.unobserve(entry.target);
        }
      });
    }, {
      threshold: 0.1,
      rootMargin: '0px 0px -40px 0px'
    });

    document.querySelectorAll('.animate-on-scroll').forEach(function(el) {
      observer.observe(el);
    });
  }

  // ── Cart count badge update ──────────────────────────────
  window.updateCartCount = function(count) {
    var badges = document.querySelectorAll('[data-cart-count]');
    badges.forEach(function(badge) {
      badge.textContent = count;
    });
  };

  document.addEventListener('cart:updated', function(event) {
    if (event.detail && typeof event.detail.item_count !== 'undefined') {
      window.updateCartCount(event.detail.item_count);
    }
  });

  // ── Quick Add to Cart ─────────────────────────────────────────────────
  document.addEventListener('click', function(e) {
    var btn = e.target.closest('.product-card__quick-add');
    if (!btn) return;

    e.preventDefault();
    e.stopPropagation();

    var variantId = btn.getAttribute('data-variant-id');
    if (!variantId) return;

    var originalText = btn.textContent;
    btn.textContent = 'Adding...';
    btn.disabled = true;

    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ id: parseInt(variantId, 10), quantity: 1 })
    })
    .then(function(r) {
      if (!r.ok) throw new Error('Failed');
      return r.json();
    })
    .then(function() {
      btn.textContent = 'Added!';
      btn.classList.add('product-card__quick-add--added');
      if (window.wdAnnounce) window.wdAnnounce('Item added to cart');
      fetch('/cart.js', { headers: { 'Accept': 'application/json' } })
        .then(function(r) { return r.json(); })
        .then(function(cart) {
          var badges = document.querySelectorAll('[data-cart-count], .nav__cart-count');
          badges.forEach(function(b) {
            b.textContent = cart.item_count;
            b.style.display = cart.item_count > 0 ? '' : 'none';
          });
        });
      setTimeout(function() {
        btn.textContent = originalText;
        btn.disabled = false;
        btn.classList.remove('product-card__quick-add--added');
      }, 2000);
    })
    .catch(function() {
      btn.textContent = 'Error';
      if (window.wdAnnounce) window.wdAnnounce('Failed to add item to cart');
      setTimeout(function() {
        btn.textContent = originalText;
        btn.disabled = false;
      }, 2000);
    });
  });

})();
